

import React, { useState, useEffect } from 'react';
import PersonIcon from '@mui/icons-material/Person';
import { APIURL } from '../../../configApi/apiConfig';
import axios from "../../../configApi/axiosConfig";

export default function ClienteInfoCard({ clientInfo, formatDate, navigate, permiso }) {
  const [firma, setFirma] = useState("");

  

  const fetchFirma = async () => {
    try {
      const response = await axios.get(APIURL.get_firma_digital_cogno(clientInfo.cedula));
      if (response.data && response.data.data) {
        setFirma(response.data.data.FIRMA || "");

      } else {
        setFirma("");

      }
    } catch (error) {
      console.error('Error al cargar firma digital del cliente:', error);
      setFirma("");
    }
  };

  useEffect(() => {
    if (clientInfo && clientInfo.cedula) {
      fetchFirma();
    }
    // eslint-disable-next-line
  }, [clientInfo.cedula]);

  return (
    <div className="max-w-5xl mx-auto">
      <div className="bg-white rounded-2xl shadow-lg border border-gray-100 p-6 md:p-8">
        <div className="flex flex-col lg:flex-row gap-8">
          {/* IZQUIERDA: FOTO + FIRMA */}
          <div className="flex flex-col items-center gap-5">
            {/* FOTO */}
            {clientInfo.foto.length < 30 ? (
              <div className="w-52 h-52 md:w-60 md:h-60 flex items-center justify-center bg-gray-100 border border-gray-200 rounded-2xl shadow-inner">
                <PersonIcon style={{ fontSize: 64, color: '#9ca3af' }} />
              </div>
            ) : (
              <img
                src={clientInfo.foto}
                alt="Foto del cliente"
                className="w-52 h-52 md:w-60 md:h-60 object-cover rounded-2xl border border-gray-200 shadow-md"
              />
            )}
            {/* FIRMA */}
            {permiso && (
            <div className="w-full text-center">
              <span className="text-xs text-gray-400 block mb-1 tracking-wide">
                FIRMA AUTORIZADA
              </span>
              <div className="bg-gray-50 border border-dashed border-gray-300 rounded-xl px-4 py-3 shadow-sm">
                {firma ? (
                   <img
                     src={`data:image/png;base64,${firma}`}
                     alt="Firma"
                     className="h-24 mx-auto object-contain opacity-90"
                   />
                ) : (
                  <img
                    src={require("../../../assets/img/Credito.png")}
                    alt="Firma"
                    className="h-12 mx-auto object-contain opacity-90"
                  />
                )}
              </div>
            </div>
            )}
          </div>
          {/* DERECHA: INFO */}
          <div className="flex-1">
            {/* HEADER */}
            <div className="mb-6">
              <h2 className="text-xl md:text-2xl font-semibold text-gray-800">
                Información del Cliente
              </h2>
              <p className="text-sm text-gray-400">Detalles de la solicitud</p>
            </div>
            {/* DATOS */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-4">
              {[
                ["Número Solicitud", clientInfo.NumeroSolicitud],
                ["Nombre", clientInfo.nombre],
                ["Cédula", clientInfo.cedula],
                ["Fecha", formatDate(clientInfo.fecha)],
                ["Vendedor", clientInfo.vendedor],
                ["Tipo de consulta", clientInfo.consulta],
                ["Almacén", clientInfo.almacen],
              ].map(([label, value], idx) => (
                <div key={idx} className="flex flex-col">
                  <span className="text-xs uppercase tracking-wide text-gray-400">
                    {label}
                  </span>
                  <span className="text-sm md:text-base font-medium text-gray-700">
                    {value || "-"}
                  </span>
                </div>
              ))}
            </div>
            {/* BOTÓN */}
            <div className="flex justify-end mt-8">
              <button
                name="aprobTodo"
                className="bg-blue-600 text-white px-6 py-2.5 rounded-xl shadow-md hover:bg-blue-700 hover:shadow-lg transition-all duration-200"
                onClick={() => navigate("/ListadoSolicitud", { replace: true })}
              >
                Regresar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
